export default "__VITE_ASSET__C7Ddv5GF__"